module.exports = __webpack_public_path__ + "static/all-1-09a50d53f249b629a2f7391790429353.mp4";